import {
  DEFAULT_TRUNCATION_MODE,
  defaultRatio,
  LEGEND_POSITION,
} from '../core/constants.js';
import {
  DEFAULT_CATEGORICAL_COLOR_PALETTE,
  DEFAULT_LABELS_DISPLAY,
  DEFAULT_LOADING_STATE,
  DEFAULT_NAME_ACCESSOR,
  DEFAULT_TEXT_SIZE,
} from './constants.js';
import {
  TreeMapConfig,
  TreemapChartLegendConfig,
} from './types/treemap-chart.config.js';

export const DEFAULT_LEGEND: TreemapChartLegendConfig = {
  position: LEGEND_POSITION.Auto,
  hidden: false,
  ratio: defaultRatio,
};

export const defaultTreeMapConfig: TreeMapConfig = {
  colorPalette: DEFAULT_CATEGORICAL_COLOR_PALETTE,
  formatter: (v: number) => v.toString(),
  truncationMode: DEFAULT_TRUNCATION_MODE,
  loading: DEFAULT_LOADING_STATE,
  legend: DEFAULT_LEGEND,
  labelsDisplay: DEFAULT_LABELS_DISPLAY,
  nameAccessor: DEFAULT_NAME_ACCESSOR,
  min: undefined,
  max: undefined,
  textSize: DEFAULT_TEXT_SIZE,
};
